<template>
    <div class="accordion mb-25 border-0" id="content-perission-accordion" v-if="categories !== undefined">
        <div class="accordion-item border-0 rounded-0">
            <button
                class="accordion-button d-block w-100 text-start text-black fs-14 fs-md-15 fs-lg-16 fw-medium rounded-0 bg-white border-0 collapsed p-15 p-sm-20 p-sm-25 p-lg-30 pe-50"
                type="button" data-bs-toggle="collapse" data-bs-target="#content-permission-tab" aria-expanded="false"
                aria-controls="content-permission-tab">
                <div class="d-sm-flex align-items-center justify-content-between">
                    <h5 class="fw-medium text-black-emphasis mb-0">{{ $t('feature.contents.content_permissions') }}</h5>
                </div>
            </button>
            <div id="content-permission-tab" class="accordion-collapse collapse border-0"
                data-bs-parent="#content-perission-accordion">
                <div class="accordion-body border-0 py-15 py-sm-20 py-sm-25 py-lg-30">
                    <div class="table-responsive">
                        <table class="table text-nowrap align-middle mb-0">
                            <thead>
                                <tr>
                                    <th scope="col"
                                        class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                        {{ $t('feature.contents.category') }}
                                    </th>
                                    <th scope="col"
                                        class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                        {{ $t('feature.contents.$categories.visible') }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <!-- PERMISSION ROW -->
                                <tr v-for="category in categories" :key="category.id">
                                    <th class="shadow-none lh-1 fw-medium text-black-emphasis title ps-0 pe-10">
                                        <div class="d-flex align-items-center justify-content-start">
                                            {{ category.name }}
                                        </div>
                                    </th>
                                    <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                        <div class="form-check form-switch form-group">
                                            <input class="form-check-input shadow-none me-8" type="checkbox" role="switch"
                                                :disabled="category.allow === 'all'" :checked="category.allow === 'all'"
                                                v-on:change="updateCategoryPermission(category)"
                                                :id="category.id?.toString()" v-model="category.patient_permission">
                                            <label class="form-check-label fw-medium position-relative top-4"
                                                v-if="category.allow === 'all'" :for="category.id?.toString()">
                                                {{ $t(`feature.contents.$categories.$visibility.${category.allow}`) }}
                                            </label>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import API from '@/services/api/api.service';
import { ContentCategory, ContentCategoryWithPatientPermission } from '@/utils/models/content.model';
import { PatientInfo } from '@/utils/models/user.model';
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'ContentPatientPermission',
    data() {
        return {
            categories: undefined as ContentCategoryWithPatientPermission[] | undefined,
            patient_categories: undefined as ContentCategory[] | undefined,
        }
    },
    computed: {
        patient() { return this.$route.meta.patient as PatientInfo },
    },
    mounted() {
        this.loadCategories();
    },
    methods: {
        loadCategories() {
            Promise.all([API.getContentCategories(), API.getPatientContentCategories({ patient_id: this.patient.id! })]).then((responses) => {
                this.categories = responses[0]?.data?.data ?? [];
                this.patient_categories = responses[1]?.data?.data ?? [];

                this.categories?.forEach((category) => {
                    category.patient_permission = this.getCategoryEnabled(category.id!);
                })
            })
        },
        getCategoryEnabled(category_id: number): boolean {
            return this.patient_categories?.map((category) => category.id!).includes(category_id) ?? false;
        },
        updateCategoryPermission(category: ContentCategoryWithPatientPermission) {
            if (category.patient_permission === false) {
                /* REMOVE PERMISSION */
                API.deletePatientContentCategoryPermission({ patient_id: this.patient.id!, content_category_id: category.id! }).catch((error) => {
                    // RESET VALUE
                    category.patient_permission = !category.patient_permission;
                });
            } else {
                /* ADD PERMISSION */
                API.setPatientContentCategoryPermission({ patient_id: this.patient.id!, content_category_id: category.id! }).catch((error) => {
                    // RESET VALUE
                    category.patient_permission = !category.patient_permission;
                });
            }
        },
    }
});
</script>